module.exports = __webpack_public_path__ + "static/media/desktop-onboarding-3.48c65444.svg";